import { c as _c } from "react/compiler-runtime";
import Skeleton from 'react-loading-skeleton';
import { LinkBlock } from '@module/mdrt-org/shared/block-components/link-block/link-block';
import { type MembershipRequirementBlockByYearData } from '../../../../utils/data/get-membership-requirement-block-by-year';
import { type KeyLinkValueBlock, type KeyLinkValueBlockLinkBlock, type MembershipRequirementBlockLinkBlock, type MembershipRequirementsBlock } from '../../../../utils/data/graphql/_generated/gql-generated';
import { type MembershipRequirementsPerYear } from '../../../../utils/types/membership-requirements';
import { RichTextBlock } from '../../../rich-text-block/rich-text-block';
import styles from './additional-requirements.module.scss';
type AdditionalRequirementsProps = {
  blockData?: MembershipRequirementsBlock;
  countryYearData?: MembershipRequirementsPerYear;
  isFetching?: boolean;
  yearBlockData?: MembershipRequirementBlockByYearData;
};
export const AdditionalRequirements = t0 => {
  const $ = _c(15);
  const {
    blockData,
    countryYearData,
    isFetching,
    yearBlockData
  } = t0;
  const renderAdditionalRequirementsLink = _temp;
  let t1;
  if ($[0] !== blockData?.MonthlyGoalChartsLinkText) {
    t1 = linkBlockData_0 => {
      if (!linkBlockData_0?.LinkToContent) {
        return;
      }
      return <LinkBlock blockData={{
        ...linkBlockData_0,
        DisplayText: blockData?.MonthlyGoalChartsLinkText || linkBlockData_0.DisplayText
      }} />;
    };
    $[0] = blockData?.MonthlyGoalChartsLinkText;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const renderMonthlyGoalChartLink = t1;
  let t2;
  if ($[2] !== blockData?.ConversionFactorsStepLabel || $[3] !== blockData?.MonthlyGoalStepName || $[4] !== blockData?.ProductionRequirementsMonthlyGoalDescription || $[5] !== countryYearData || $[6] !== isFetching || $[7] !== renderMonthlyGoalChartLink || $[8] !== yearBlockData?.ConversionFactorsDescription || $[9] !== yearBlockData?.DownloadRequirementsLink || $[10] !== yearBlockData?.GenericProductionFooterText || $[11] !== yearBlockData?.MonthlyGoalCharts || $[12] !== yearBlockData?.NonCoreDownloadRequirementsLink || $[13] !== yearBlockData?.SpecificProductionFooterText) {
    const relevantMonthlyGoalChart = yearBlockData?.MonthlyGoalCharts?.find(monthlyGoalChart => (monthlyGoalChart?.ContentLink?.Expanded as KeyLinkValueBlock | undefined)?.Name === countryYearData?.country);
    const monthlyGoalChartContent = relevantMonthlyGoalChart?.ContentLink?.Expanded as KeyLinkValueBlock | undefined;
    t2 = <div className={styles.requirements}>{isFetching ? <Skeleton className={styles.skeleton} /> : <>{countryYearData?.showProductionFooter ? <div className={styles["requirements__note-wrapper"]}><RichTextBlock className={styles["requirements__note-wrapper--block"]} html={yearBlockData?.SpecificProductionFooterText ?? ""} />{countryYearData.unlimitedProductionNotRequired ? renderAdditionalRequirementsLink(yearBlockData?.NonCoreDownloadRequirementsLink) : renderAdditionalRequirementsLink(yearBlockData?.DownloadRequirementsLink)}</div> : <div className={styles["requirements__note-wrapper"]}><RichTextBlock className={styles["requirements__note-wrapper--block"]} html={yearBlockData?.GenericProductionFooterText ?? ""} />{countryYearData?.unlimitedProductionNotRequired ? renderAdditionalRequirementsLink(yearBlockData?.NonCoreDownloadRequirementsLink) : renderAdditionalRequirementsLink(yearBlockData?.DownloadRequirementsLink)}</div>}<div className={styles["requirements__conversion-factors-wrapper"]}><h3>{blockData?.ConversionFactorsStepLabel}</h3><RichTextBlock className={styles["requirements__conversion-factors-wrapper--block"]} html={yearBlockData?.ConversionFactorsDescription ?? ""} noParagraphGutters={true} /></div>{countryYearData?.showMonthlyGoalChart && <div className={styles["requirements__monthly-goals-wrapper"]}><h3>{blockData?.MonthlyGoalStepName}</h3><RichTextBlock html={blockData?.ProductionRequirementsMonthlyGoalDescription ?? ""} />{renderMonthlyGoalChartLink(monthlyGoalChartContent?.Value)}</div>}</>}</div>;
    $[2] = blockData?.ConversionFactorsStepLabel;
    $[3] = blockData?.MonthlyGoalStepName;
    $[4] = blockData?.ProductionRequirementsMonthlyGoalDescription;
    $[5] = countryYearData;
    $[6] = isFetching;
    $[7] = renderMonthlyGoalChartLink;
    $[8] = yearBlockData?.ConversionFactorsDescription;
    $[9] = yearBlockData?.DownloadRequirementsLink;
    $[10] = yearBlockData?.GenericProductionFooterText;
    $[11] = yearBlockData?.MonthlyGoalCharts;
    $[12] = yearBlockData?.NonCoreDownloadRequirementsLink;
    $[13] = yearBlockData?.SpecificProductionFooterText;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
};
function _temp(linkBlockData) {
  if (!linkBlockData?.LinkToContent) {
    return;
  }
  return <LinkBlock blockData={linkBlockData} />;
}